<div class="tab-content">
  <div class="page-title">
    <span translate>ADD_INSTRUMENT</span>
  </div>
  <form [formGroup]="measureProtocolInstrumentForm">
    <div class="form-group">
      <label for="Title">
        <span translate>TYPE</span>
        <span class="required">*</span>
      </label>
      <div class="input-btn-group">
        <p-select
          [filter]="true"
          formControlName="InstrumentTypeId"
          [options]="types"
          [style]="{ width: '100%' }"
        ></p-select>
        <button
          class="btn btn-outline-primary"
          type="button"
          (click)="addType = !addType"
        >
          <i class="pi pi-plus" aria-hidden="true"></i>
        </button>
      </div>
      <control-messages
        [control]="measureProtocolInstrumentForm.controls['InstrumentTypeId']"
      ></control-messages>
    </div>
    <div class="form-group">
      <label for="Title">
        <span translate>MODEL</span>
        <span class="required">*</span>
      </label>
      <div class="input-btn-group">
        <p-select
          [filter]="true"
          formControlName="InstrumentModelId"
          [options]="models"
          [style]="{ width: '100%' }"
        ></p-select>
        <button
          class="btn btn-outline-primary"
          type="button"
          (click)="addModel = !addModel"
        >
          <i class="pi pi-plus" aria-hidden="true"></i>
        </button>
      </div>
      <control-messages
        [control]="measureProtocolInstrumentForm.controls['InstrumentModelId']"
      >
      </control-messages>
    </div>
    <div class="form-group">
      <label>
        <span translate>CALIBRATED_DATE</span>
        <span class="required">*</span>
      </label>
      <div>
        <p-datepicker
          [style]="{ width: '160px' }"
          formControlName="CalibratedDate"
          [showButtonBar]="true"
          [placeholder]="'Select Calibrated Date' | translate"
          dateFormat="dd/mm/yy"
          [style]="{ width: '100%' }"
          [showIcon]="true"
        ></p-datepicker>
      </div>
      <control-messages
        [control]="measureProtocolInstrumentForm.controls['CalibratedDate']"
      ></control-messages>
    </div>
    <div class="action-btns-wrapper">
      <button class="btn btn-outline-secondary" (click)="gotoBack()">
        <i class="pi pi-arrow-left"></i>
        <span translate>BACK_LIST</span>
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="measureProtocolInstrumentForm.invalid"
        (click)="saveChanges()"
      >
        <span translate>SAVE_CREATE_NEW</span>
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="measureProtocolInstrumentForm.invalid"
        (click)="saveChanges()"
      >
        <span translate>SAVE</span>
      </button>
    </div>
  </form>
</div>

<p-dialog
  header="{{ 'TYPE' | translate }}"
  (onHide)="oninstrumentTypeFormHide()"
  [(visible)]="addType"
  [modal]="true"
  [style]="{ width: '350px' }"
  [resizable]="false"
  [draggable]="false"
>
  <form [formGroup]="instrumentTypeForm">
    <div class="form-group">
      <label for="title" class="col-form-label">
        <span translate>TYPE</span>
        <span class="required">*</span>
      </label>
      <div>
        <input
          type="text"
          formControlName="Name"
          class="label-input form-control"
          required
        />
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
      <button
        type="button"
        class="btn btn-outline-primary"
        (click)="viewType = !viewType"
        (click)="viewInstrumentType()"
      >
        <span translate>VIEW</span>
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="instrumentTypeForm.invalid"
        (click)="saveType()"
      >
        <span translate>SAVE</span>
      </button>
    </div>
    <div *ngIf="viewType">
      <div class="table-view">
        <!-- Table starts -->
        <p-table
          #et
          [value]="editTypes"
          [rows]="5"
          [paginator]="true"
          [pageLinks]="3"
          [rowsPerPageOptions]="[5, 10, 20]"
        >
          <!-- Header -->
          <ng-template pTemplate="header">
            <tr>
              <th>{{ "Type" | translate }}</th>
              <th></th>
            </tr>
            <tr>
              <th>
                <input
                  pInputText
                  type="text"
                  (input)="et.filter($event.target.value, 'Name', 'contains')"
                  placeholder=""
                  class="p-column-filter"
                />
              </th>
              <th></th>
            </tr>
          </ng-template>
          <!-- Body Content -->
          <ng-template pTemplate="body" let-categoryType>
            <tr>
              <td>
                <span>{{ categoryType.Name }}</span>
              </td>
              <td class="col-button">
                <button
                  type="button"
                  title="{{ 'EDIT' | translate }}"
                  (click)="editType(categoryType)"
            [attr.aria-label]="'EDIT' | translate" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row">
            <i class="pi pi-pencil"></i>
          </button>
                <button
                  type="button"
                  title="{{ 'DELETE' | translate }}"
                  (click)="deleteType(categoryType)"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
              </td>
            </tr>
          </ng-template>
          <!-- Empty message -->
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td colspan="2">
                {{ "NO_RECORDS_FOUND" | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
        <!-- Table Ends-->
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="{{ 'MODEL' | translate }}"
  (onHide)="oninstrumentModelFormHide()"
  [(visible)]="addModel"
  [modal]="true"
  [style]="{ width: '350px' }"
  [resizable]="false"
  [draggable]="false"
>
  <form [formGroup]="instrumentModelForm">
    <div class="form-group">
      <label for="title" class="col-form-label">
        <span translate>MODEL</span>
        <span class="required">*</span>
      </label>
      <div>
        <input
          type="text"
          formControlName="Name"
          class="label-input form-control"
          required
        />
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
      <button
        type="button"
        class="btn btn-outline-primary"
        (click)="viewType = !viewType"
        (click)="viewModelType()"
      >
        <span translate>VIEW</span>
      </button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="instrumentModelForm.invalid"
        (click)="saveModel()"
      >
        <span translate>SAVE</span>
      </button>
    </div>
    <div *ngIf="viewType">
      <div class="table-view">
        <p-table
          #type
          [value]="editModels"
          [rows]="5"
          [paginator]="true"
          [pageLinks]="3"
          [rowsPerPageOptions]="[5, 10, 20]"
        >
          <!-- Header -->
          <ng-template pTemplate="header">
            <tr>
              <th>{{ "Type" | translate }}</th>
              <th></th>
            </tr>
            <tr>
              <th>
                <input
                  pInputText
                  type="text"
                  (input)="
                    type.filter($any($event.target)?.value, 'Name', 'contains')
                  "
                  placeholder=""
                  class="p-column-filter"
                />
              </th>
              <th></th>
            </tr>
          </ng-template>
          <!-- Body Content -->
          <ng-template pTemplate="body" let-business>
            <tr>
              <td>{{ business.Name }}</td>
              <td>
                <button
                  type="button"
                  title="{{ 'EDIT' | translate }}"
                  (click)="editType(business)"
            [attr.aria-label]="'EDIT' | translate" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row">
            <i class="pi pi-pencil" aria-hidden="true"></i>
          </button>
                <button
                  type="button"
                  (click)="deleteType(business.Id)"
                  title="{{ 'DELETE' | translate }}"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
              </td>
            </tr>
          </ng-template>
          <!-- Empty message -->
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td colspan="2">
                {{ "NO_RECORDS_FOUND" | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </ng-template>
</p-dialog>
<p-confirmDialog
  header="{{ 'CONFIRMATION' | translate }}"
  icon="pi pi-question-circle"
  width="425"
  acceptLabel="{{ 'SWITCH_YES' | translate }}"
  rejectLabel="{{ 'SWITCH_NO' | translate }}"
></p-confirmDialog>
